// Copyright (c) 2017 Deere & Company

import AuditListContainer from './audit-list';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    auditList: state.tcsm.audits.auditList,
    confirmationModal: state.tcsm.audits.confirmationModal,
    searchFilters: state.tcsm.audits.searchFilters

});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const {
        resetConfirmationModal,
        setConfirmationModal,
        updateFilterBy,
        updateSkipAudit,
        updateSortBy,
        updateSortDirection
    } = dispatchProps;

    return {
        ...stateProps,
        actions: {
            resetConfirmationModal,
            setConfirmationModal,
            updateFilterBy,
            updateSkipAudit,
            updateSortBy,
            updateSortDirection
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(AuditListContainer);



// WEBPACK FOOTER //
// ./src/tcsm/audits/components/audit-list/index.js